import { useCallback, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { Search } from "lucide-react";
import { Button } from "@/components/ui/button";
import { FormField } from "@/components/FormBits";
import { OrderDetail } from "@/components/OrderDetail";
import { api, formatError } from "@/lib/api";

export default function TrackOrder() {
  const [params] = useSearchParams();
  const [number, setNumber] = useState(params.get("numero") || "");
  const [email, setEmail] = useState(params.get("email") || "");
  const [order, setOrder] = useState(null);
  const [busy, setBusy] = useState(false);

  const lookup = useCallback(async (n, e) => {
    setBusy(true);
    try {
      const { data } = await api.post("/orders/lookup", { number: n, email: e });
      setOrder(data);
    } catch (err) {
      setOrder(null);
      toast.error(formatError(err));
    } finally {
      setBusy(false);
    }
  }, []);

  useEffect(() => {
    const n = params.get("numero"), e = params.get("email");
    if (n && e) lookup(n, e);
  }, [params, lookup]);

  return (
    <div className="mx-auto max-w-4xl space-y-8 px-4 py-12 sm:px-6 lg:px-8">
      <div>
        <h1 className="font-display text-3xl font-extrabold tracking-tight sm:text-4xl">Rastrear pedido</h1>
        <p className="text-slate-500">Informe o número do pedido e o e-mail usado na compra.</p>
      </div>
      <form onSubmit={(e) => { e.preventDefault(); lookup(number, email); }} className="grid items-end gap-4 rounded-md border border-slate-200 bg-white p-6 sm:grid-cols-[1fr_1fr_auto]" data-testid="track-form">
        <FormField id="track-number" label="Número do pedido" placeholder="SAN-XXXXXX" required value={number} onChange={(e) => setNumber(e.target.value)} />
        <FormField id="track-email" label="E-mail" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} />
        <Button type="submit" disabled={busy} className="h-11 rounded-full bg-slate-900 px-6 hover:bg-[#0099DD]" data-testid="btn-track-submit">
          <Search className="h-4 w-4" /> {busy ? "Buscando..." : "Consultar"}
        </Button>
      </form>
      {order && <OrderDetail order={order} />}
    </div>
  );
}
